import { useUploadStore } from '../../../../store/uploadStore';
import { getAverageBytesPerSecond } from './useMeasureUploadSpeed';
import { getAverageRegistrationTimeMs } from './trackFileRegistrationTime';
import Logger from '../../../../libs/logger/Logger';
import { sendUploadSpeedMetric } from '../metrics/sendUploadSpeedMetric';

export const setupUpdateSpeedInterval = () => {
  let previousBytesPerSecond: number | null = null;

  setInterval(() => {
    const store = useUploadStore.getState();

    const bytesPerSecond = getAverageBytesPerSecond();
    const megaBitsPerSecond = ((bytesPerSecond * 8) / 1_000_000).toFixed(2);

    const averageRegistrationTimeMs = getAverageRegistrationTimeMs();

    store.setBytesPerSecond(bytesPerSecond);
    store.setFileRegistrationTimeMs(averageRegistrationTimeMs);

    Logger.log(
      `Average upload speed: ${megaBitsPerSecond} mbps; average file registration speed: ${getAverageRegistrationTimeMs()} ms`,
    );

    if (bytesPerSecond !== previousBytesPerSecond) {
      previousBytesPerSecond = bytesPerSecond;
      sendUploadSpeedMetric(bytesPerSecond);
    }
  }, 60000);
};
